import httpClient from '../../httpClient';

export const getAllStores = () => {
  return httpClient({
    method: 'GET',
    url: '/super-admin/stores/all',
  });
};

export const updateIndividualValueForStore = (id, data) => {
  return httpClient({
    method: 'PUT',
    url: `/super-admin/stores/${id}/update`,
    data,
  });
};

export const updateIndividualValueForStoreSettings = (id, data) => {
  return httpClient({
    method: 'PUT',
    url: `/super-admin/stores/${id}/settings/update`,
    data,
  });
};

export const updateValueForPrinterSettings = (id, data) => {
  return httpClient({
    method: 'PUT',
    url: `/super-admin/stores/${id}/printer/settings/update`,
    data,
  });
};

export const updateIndividualValueForCentsDeliverySettings = (id, data) => {
  return httpClient({
    method: 'PUT',
    url: `/super-admin/stores/${id}/cents-delivery-settings`,
    data,
  });
};

export const searchStores = (searchInput) => {
  return httpClient({
    method: 'GET',
    url: '/super-admin/stores/all/search',
    params: {
      searchTerm: searchInput,
    },
  });
};

export const updateStorePassword = (storeId, data) => {
  return httpClient({
    method: 'PUT',
    url: `/super-admin/stores/${storeId}/password/save`,
    data,
  });
};

export const getStoreServiceOrders = (pageNumber, storeId, searchTerm) => {
  return httpClient({
    method: 'GET',
    url: `/super-admin/stores/${storeId}/service-orders`,
    params: {
      pageNumber,
      searchTerm,
    },
  });
};

export const getStoreInventoryOrders = (pageNumber, storeId, searchTerm) => {
  return httpClient({
    method: 'GET',
    url: `/super-admin/stores/${storeId}/inventory-orders`,
    params: {
      pageNumber,
      searchTerm,
    },
  });
};

export const createNewStore = (data) => {
  return httpClient({
    method: 'POST',
    url: '/super-admin/stores',
    data,
  });
};
